import { Zone } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import useHomeType from './useHomeType'

export const GET_ZONES = `/api/list/zones`

type UseZonesResponse = {
  isLoading: boolean
  zones: Zone[]
  fetchZones: () => void
}

const useZones = (): UseZonesResponse => {
  const { isPro, features } = useHomeType()

  const { isLoading, data, refetch } = useQuery(
    'zones',
    () => getJSON({ url: GET_ZONES }),
    { enabled: isPro && features?.zones?.enabled },
  )

  return {
    isLoading,
    zones: data?.result || [],
    fetchZones: refetch,
  }
}

export default useZones
